class ProductUpsellSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    setTimeout(() => {
      this.style.display = '';
      this.classList.remove('loading');
    }, 250);
  }
}

class ProductSwatchUpsell extends HTMLElement {
  constructor() {
    super();
    this.variant = null;
    this.variants = JSON.parse(
      this.querySelector('input[type="hidden"]')
        .getAttribute('variants_array')
        .replaceAll(`'`, `"`));
    this.variant_options_selected = {
      option1: '',
      option2: '',
      option3: '',
    };
    this.color_label = this.querySelector('small[aria-label="color label"]');
    this.options_quantity = parseInt(
      this.querySelector('input[type="hidden"]').getAttribute(
        'options_quantity'
      )
    );
    this.color_btns = this.querySelectorAll('product-color-upsell');
    this.options_btns = [...this.querySelectorAll('product-option-upsell')];
    this.tooltips = this.querySelectorAll('tooltip-component');
    this.atc_msg = this.querySelector(
      'product-atc-upsell .variant-title-upsell'
    );
    this.atc_button = this.querySelector('product-atc-upsell button');
    this.picture = this.querySelector('picture');
  }
  connectedCallback() {
    this.color_btns.forEach((btn) =>
      btn.addEventListener('click', this.selectColor.bind(this, btn))
    );
    this.options_btns.forEach((btn) =>
      btn.addEventListener('click', this.selectOption.bind(this, btn))
    );
    this.atc_button.addEventListener(
      'click',
      this.addToCart.bind(this, this.atc_button)
    );
    if(this.variants.length === 1) {
      this.variant = this.variants[0];
      this.atc_button.disabled = false;
    }
    this.picture.addEventListener('click', this.togglePicture.bind(this));
  }
  togglePicture() {
    this.picture.classList.toggle('open');
    document.body.style.overflow = this.picture.classList.contains('open') ? 'hidden' : 'auto';
    document.querySelector('.theme__header ').style.display = this.picture.classList.contains('open') ? 'none' : 'block';
  }
  selectColor(btn) {
    const image = btn.getAttribute('data-image');
    const color = btn.getAttribute('value');
    const productId = btn.getAttribute('data-product-id');
    this.variant_options_selected.option1 = color;
    const colorVariantsAvailable = this.variants.filter(
      (variant) => variant.option1 === color
    );

    for (let i = 1; i <= this.options_quantity; i++) {
      if (i <= 1) continue;
      const productOptionsUpsale = this.options_btns.filter((btn) =>
        btn.querySelector(`input[option-position="${i}"]`)
      );
      const nextOptionsAvaible = colorVariantsAvailable.map(
        (variant) => variant[`option${i}`]
      );
      const label = document.getElementById(`${productId}--${i}`);
      label.textContent = '';
      this.variant_options_selected[`option${i}`] = '';
      productOptionsUpsale.forEach((option) => {
        const input = option.querySelector('input');
        input.checked = false;
        input.classList.add('disabled');
        if (nextOptionsAvaible.includes(input.value)) {
          input.classList.remove('disabled');
        }
      });
    }

    this.querySelector(`source[data-product-id="${productId}"]`).srcset = image;
    this.querySelector(`img[data-product-id="${productId}"]`).src = image;

    const tooltip = btn.querySelector('tooltip-component');
    this.tooltips.forEach((tooltip) => tooltip.classList.remove('selected'));
    this.color_label.textContent = color;
    tooltip.classList.add('selected');
    this.toggleAddToCartButton();
  }
  selectOption(btn) {
    const productId = btn.getAttribute('data-product-id');
    const position = parseInt(
      btn.querySelector('input').getAttribute('option-position')
    );
    const label = document.getElementById(`${productId}--${position}`);
    const input = btn.querySelector('input');
    label.textContent = input.value;
    this.variant_options_selected[`option${position}`] = input.value;
    this.toggleAddToCartButton();
  }
  findVariant() {
    const options = Object.values(this.variant_options_selected).filter(
      (option) => option !== ''
    );
    const variants = this.variants.filter((variant) => {
      switch (options.length) {
        case 1:
          return variant.option1 === options[0];
        case 2:
          return (
            variant.option1 === options[0] && variant.option2 === options[1]
          );
        case 3:
          return (
            variant.option1 === options[0] &&
            variant.option2 === options[1] &&
            variant.option3 === options[2]
          );
      }
    });
    if (variants.length === 1) {
      this.variant = variants[0];
      return this.variant;
    }
    return false;
  }
  areAllOptionsSelected() {
    const optionsSelected = Object.values(this.variant_options_selected).filter(
      (option) => option !== ''
    );
    if (optionsSelected.length === this.options_quantity) {
      return true;
    }
    return false;
  }
  toggleAddToCartButton() {
    const variant = this.findVariant();
    const areAllOptionsSelected = this.areAllOptionsSelected();
    if (areAllOptionsSelected && variant) {
      this.atc_button.disabled = false;
      this.atc_button.querySelector('.btn__text').textContent =
        'Agregar al carrito';
      this.atc_msg.textContent = '';
    } else if (areAllOptionsSelected && !variant) {
      this.atc_button.disabled = true;
      this.atc_button.querySelector('.btn__text').textContent = 'Agotado';
    } else {
      this.atc_button.disabled = true;
      this.atc_button.querySelector('.btn__text').textContent =
        'Agregar al carrito';
      this.atc_msg.textContent = 'Selecciona las opciones faltantes.';
    }
  }
  async addToCart(button) {
   button.disabled = true;
    const cart = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: this.variant.id, quantity: 1 }),
    });
    await cart.json();
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
      bubbles: true,
    }));
    button.disabled = false;
  }
}

class ProductUpsellMobile extends HTMLElement {
  constructor() {
    super();
    this.is_active = false;
    this.header = document.querySelector('.theme__header');
    this.doc = document.querySelector('body');
    this.id = this.dataset.productId;
    this.back = this.querySelector('.product-upsell__card-mobile__backdrop');
    this.btn = this.querySelector('button.toggle-product-upsell');
    this.swatch = document.querySelector(`product-swatch-upsell[data-product-id="${this.id}"]`);
    this.close = this.swatch.querySelector(`.close-product-upsell`);
  }
  connectedCallback() {
    this.btn.addEventListener('click', this.toggleProductUpsellMobile.bind(this));
    this.close.addEventListener('click', this.toggleProductUpsellMobile.bind(this));
    document.addEventListener('theme:cart:refresh', this.closeProductUpsellMobile.bind(this));
  }
  toggleProductUpsellMobile() {
    this.swatch.classList.toggle('slide');
    this.back.classList.toggle('hidden');
    this.header.classList.toggle('has-backdrop');
    this.doc.classList.toggle('has-backdrop');
    this.is_active = !this.is_active;
  }
  closeProductUpsellMobile() {
    if(this.is_active) {
      setTimeout(() => {
        this.toggleProductUpsellMobile();        
      }, 1000);
    } 
  }
}

customElements.define('product-upsell-card', ProductUpsellSection);
customElements.define('product-swatch-upsell', ProductSwatchUpsell);
customElements.define('product-upsell-card-mobile', ProductUpsellMobile);
